/*
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Internal dependencies
 */
import {
  AUDIO_STICKER_ASPECT_RATIOS,
  AUDIO_STICKER_WIDTH_PRESETS,
} from '../../../../constants';

export function getDimensionsForAudioSticker(type, size) {
  let width, height;
  if (size === 'small') {
    width =
      AUDIO_STICKER_WIDTH_PRESETS.SMALL * AUDIO_STICKER_ASPECT_RATIOS[type];
    height = AUDIO_STICKER_WIDTH_PRESETS.SMALL;
  } else {
    width =
      AUDIO_STICKER_WIDTH_PRESETS.LARGE * AUDIO_STICKER_ASPECT_RATIOS[type];
    height = AUDIO_STICKER_WIDTH_PRESETS.LARGE;
  }

  return { width, height };
}
